export class RoadKillGameConfig {
    //Number of reels
    public static REELS_NUM: number = 5;

    //Symbol information
    public static SYMBOL_HEIGHT: number = 160;
    public static SYMBOL_WIDTH: number = 144;


    public static STEP_DURATION: number = 0.042;

    public static REEL_STOP_DELAY: number = RoadKillGameConfig.STEP_DURATION * 6;
    public static REEL_STOP_FAST_SPIN_DELAY: number = RoadKillGameConfig.STEP_DURATION ;

    public static WILD_SYMBOLS: string[] = ["SW1", "SW2", "SW3"];

    public static HIDE_AND_ALPHA_DURATION:number=0.55;

    public static WAYS_STYLE={
        dropShadow: true,
        dropShadowAngle: 7.5,
        fill: "white",
        fontFamily: "Helvetica",
        fontSize: 35,
        fontStyle: "italic",
        fontWeight: "bold",
        miterLimit: 0,
        strokeThickness: 3
    }
}